module.exports = __webpack_public_path__ + "img/user.8ce66818.png";